import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const table = css`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};

  th,
  td {
    text-align: left;
    padding: ${spacing(3)} ${spacing(4)};
  }

  /*
    Sticky header — pins to the top of the scrollable cards container so
    the column labels stay visible while the user scrolls through a long
    selection. position: sticky needs to be on the cells, not <thead>,
    for border-collapse + cross-browser reliability.

    Header sits on base_colorSurface (the slightly tinted off-white) so
    it reads as the chrome of the table, while the data cells use the
    pure-white base_colorRaisedSurface so they pop forward as the
    primary content area.
  */
  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: ${base_colorSurface};
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  thead th:first-child {
    border-top-left-radius: ${spacing(2)};
  }
  thead th:last-child {
    border-top-right-radius: ${spacing(2)};
  }

  td {
    background-color: ${base_colorRaisedSurface};
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextPrimary};
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: ${spacing(2)};
  }
  tbody tr:last-child td:last-child {
    border-bottom-right-radius: ${spacing(2)};
  }
`

/*
  Doubled selector for specificity: the parent table style sets a
  default `td { font-family: regular }`, which beats a single-class
  override on the cell. `&&` generates two of the same class on the
  element, so this wins without resorting to !important.
*/
export const cardNameCell = css`
  && {
    font-family: ${font_family_weight_medium};
  }
`

export const cardNumberCell = css`
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  white-space: nowrap;
`
